import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { FormField } from '../../../components/FormFields';
import { Checkbox } from '../../../components/Checkbox';
import { Loader } from 'react-feather';
import { Calendar } from '../../../components/Icon';
import { IsOpen } from '../../../components/Icon';
import { IconRightDecorator } from '../../../components/Icon/IconRightDecorator';
import { getDate } from '../../Vehicles/helpers';
import { selectWorks } from '../../Api/selectors';
import {
  VEHICLE_DETAILS_VEHICLE_DATA_CARD,
  REQUEST_VEHICLE_PROPERTIES,
} from '../../Vehicles/constants';
import { WEBLOGIN_FETCH_VEHICLE } from '../constants';

dayjs.extend(customParseFormat);

const Container = styled.div`
  font-size: 14px;
  .card-header {
    margin-bottom: 20px;
  }

  .info-card {
    min-width: 260px;
    width: 100%;
  }

  .card-title {
    white-space: nowrap;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .info-cell {
    white-space: nowrap;
  }

  .info-cell:hover {
    cursor: pointer;
  }

  img {
    margin: 10, 0, 0, 0;
  }

  @media (max-width: 390px) {
    .row-property {
    font-size: 12px;
  }
  }

  
`;

const STATE = {
  isOpen: false,
};

/* eslint-disable react/prefer-stateless-function */
class WebloginVehicleDataCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    VEHICLE_DETAILS_VEHICLE_DATA_CARD.map(property => {
      if (this.props.vehicle[property]) {
        this.setState({ [property]: this.props.vehicle[property] });
      }
    });
  }

  isImportDisabled() {
    return !!this.props?.vehicle?.incoming_invoice;
  }

  checkbox(type) {
    let disabled = false;
    if (type === 'import') disabled = this.isImportDisabled();
    return (
      <FormField>
        <Checkbox onChange={() => {}} checked={this.state[type] == '1'} disabled={disabled}></Checkbox>
      </FormField>
    );
  }

  datePicker(type) {
    let format = this.state[type]?.charAt(2) == '-' ? 'DD-MM-YYYY' : undefined;

    let selected = this.state[type] && this.state[type] !== 'null' && dayjs(this.state[type], format);
    return (
      <HBox>
        <FormField>
          <DatePicker
            dateFormat="dd-MM-yyyy"
            selected={selected && selected != 'Invalid Date' && selected.toDate()}
            onChange={date => {
              let d = dayjs(date).format('YYYY-MM-DD hh:mm:ss');
              this.setState({ [type]: d });
            }}
          />
          <IconRightDecorator icon={<Calendar />} />
        </FormField>
      </HBox>
    );
  }

  isShowPropertyCell(type) {
    if (this.props.vehicle[type] && this.props.vehicle[type] !== 'null') {
      return true;
    }
    return false;
  }

  render() {
    const vehicle = this.props.vehicle;

    if (this.props.work) return <Loader small />;

    return (
      <Container>
      <Card className="vehicle-info-card info-card data">
        
      <HBox>
            <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.data.vehicle_data')}</h2>

            {window.innerWidth <= 768 && (
              <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                <IsOpen />
              </div>
            )}
        </HBox>
          {(this.state.isOpen || window.innerWidth > 768) && (
            <List>
              {VEHICLE_DETAILS_VEHICLE_DATA_CARD.map(property => {
                if (this.isShowPropertyCell(property) && property === 'mileage') {
                  return (
                    <Row className="row-property" key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="info-cell">{vehicle[property]} km</Cell>
                    </Row>
                  );
                }

                if (property === 'new_from_factory') {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell>{this.checkbox(property)}</Cell>
                    </Row>
                  );
                }
                if (property === 'import') {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell>{this.checkbox(property)}</Cell>
                    </Row>
                  );
                }

                if (property === 'ex_rental') {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell>{this.checkbox(property)}</Cell>
                    </Row>
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'power') {
                  return (
                    <Row className="row-property" key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="info-cell">{vehicle[property]} KW</Cell>
                    </Row>
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'battery_capacity') {
                  return (
                    <Row className="row-property" key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="info-cell">{vehicle[property]} KW/h</Cell>
                    </Row>
                  );
                }
                if (this.isShowPropertyCell(property) && property === 'date_first_allowance') {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="info-cell">{getDate(vehicle[property])}</Cell>
                    </Row>
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'date_expected') {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="info-cell">{getDate(vehicle[property])}</Cell>
                    </Row>
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'fuel_type') {
                  return (
                    vehicle[property] && (
                      <Row className="row-property" key={property}>
                        <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                        <Cell className="info-cell">{vehicle[property]}</Cell>
                      </Row>
                    )
                  );
                }
                if (this.isShowPropertyCell(property) && property === 'transmission_type') {
                  return (
                    vehicle[property] && (
                      <Row className="row-property" key={property}>
                        <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                        <Cell className="info-cell">{vehicle[property]}</Cell>
                      </Row>
                    )
                  );
                }
                if (this.isShowPropertyCell(property) && property === 'body_type') {
                  return (
                    this.isShowPropertyCell(property) && (
                      <Row className="row-property" key={property}>
                        <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                        <Cell className="info-cell">{vehicle[property]}</Cell>
                      </Row>
                    )
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'base_color') {
                  return (
                    this.isShowPropertyCell(property) && (
                      <Row className="row-property" key={property}>
                        <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                        <Cell className="info-cell">{vehicle[property]}</Cell>
                      </Row>
                    )
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'secondary_color') {
                  return (
                    this.isShowPropertyCell(property) && (
                      <Row className="row-property" key={property}>
                        <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                        <Cell className="info-cell">{vehicle[property]}</Cell>
                      </Row>
                    )
                  );
                }

                if (this.isShowPropertyCell(property) && property === 'power_axle') {
                  return (
                    this.isShowPropertyCell(property) && (
                      <Row className="row-property" key={property}>
                        <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                        <Cell className="info-cell">{vehicle[property]}</Cell>
                      </Row>
                    )
                  );
                }
                return (
                  this.isShowPropertyCell(property) && (
                    <Row className="row-property" key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>

                      <Cell className="info-cell">{vehicle[property]}</Cell>
                    </Row>
                  )
                );
              })}
            </List>
          )}
      </Card>
      </Container>
    );
  }
}

WebloginVehicleDataCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([WEBLOGIN_FETCH_VEHICLE, `${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicle?.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WebloginVehicleDataCard = compose(withConnect, withRouter)(WebloginVehicleDataCardComp);
